import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "components/common";
import { importPartners } from "api";

export default function ImportPartnersPage() {
  const navigate  = useNavigate();
  const inputRef  = useRef<HTMLInputElement>(null);
  const [file, setFile]         = useState<File | null>(null);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState<string | null>(null);

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const selected = e.target.files?.[0] ?? null;
    setFile(selected);
    setError(null);
  }

  async function handleUpload() {
    if (!file) return;
    setLoading(true);
    setError(null);
    try {
      const result = await importPartners(file);
      navigate("/tools/import-partners/summary", { state: { result } });
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { error?: string } } })?.response?.data?.error
        ?? (err as Error)?.message
        ?? "An error occurred";
      setError(msg);
      setLoading(false);
    }
  }

  return (
    <div className="px-4 py-6 sm:px-8 sm:py-8 max-w-lg">
      <PageHeader title="Import bulk partners" subtitle="Upload a CSV to create multiple Partner Entities at once." />

      <div className="card p-6 mt-4 space-y-4">
        <div>
          <p className="text-xs text-gray-500 mb-3">
            The CSV must include <strong>Partner type</strong> and <strong>Partner Name</strong> columns.
            Rows missing either value will be skipped. Optional columns: St Address, City, State, Zip,
            Contact name, Contact email, Contact phone.
          </p>

          <label className="block text-xs font-medium text-gray-700 mb-1">CSV file</label>
          <div
            className="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={() => inputRef.current?.click()}
          >
            <span className="text-xs text-gray-500 truncate">
              {file ? file.name : "Choose a file…"}
            </span>
            <span className="text-xs font-medium text-gray-600 ml-3 shrink-0">Browse</span>
          </div>
          <input
            ref={inputRef}
            type="file"
            accept=".csv,text/csv"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>

        {error && (
          <div className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">
            {error}
          </div>
        )}

        <button
          className="btn-primary w-full"
          disabled={!file || loading}
          onClick={handleUpload}
        >
          {loading ? "Processing…" : "Upload"}
        </button>
      </div>
    </div>
  );
}
